<template>
  <div class="page">
    <Tab :index="index" @tap="tabClick"></Tab>
    <div style="margin-top: 20px;"></div>
    <!-- 销售数据看板 -->
    <!-- TODO：这里写一个销售数据看板组件 -->
     <!-- 业绩看板 -->
    <salesPerformanceDashboard v-if="index === 3" ref="salesRef"></salesPerformanceDashboard>
    <!-- 个人赛参赛数据总览 -->
    <signupStatistics ref="susRef" v-else-if="index === 1"></signupStatistics>
    <!-- 个人赛考量申请 -->
    <considerationDataStatistics ref="cdsRef" v-else-if="index === 2"></considerationDataStatistics>
    <el-empty v-else description="暂无内容"></el-empty>
  </div>
</template>

<script>
import signupStatistics from '../raceManagement/individual_management/raceManagement_childview/individual_racing_tool/signup_statistics.vue'
import considerationDataStatistics from '../raceManagement/individual_management/raceManagement_childview/individual_racing_tool/consideration_data_statistics.vue'
import salesPerformanceDashboard from '../raceManagement/individual_management/raceManagement_childview/individual_racing_tool/sales_performance_dashboard.vue'
import { hasPermission } from '@/permission/index.js'
import Tab from '@/components/cdata_tab_component.vue'

// import ProductTab from '../../../components/product_tab_component.vue'
export default {
  name: 'dataManagementHome',
  components: {
    signupStatistics, considerationDataStatistics, salesPerformanceDashboard, Tab
  },
  // ProductTab
  data () {
    return {
      // id: '1',
      index: 3
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.salesRef.getData()
    })
  },
  methods: {
    tabClick (index) {
      console.log(index)
      this.index = index
      // setTimeout(() => {
      if (this.index === 1) {
        this.$nextTick(() => {
          this.$refs.susRef.getData()
        })
      } else if (this.index === 2) {
        this.$nextTick(() => {
          this.$refs.cdsRef.getData()
        })
      } else if (this.index === 3) {
        this.$nextTick(() => {
          this.$refs.salesRef && this.$refs.salesRef.getData()
        })
      }
      // })
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms) // & !this.disabled
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .el-tabs--border-card {
  background-color: transparent;
  box-shadow: none;
}
</style>
